import {
  VerticalMenuSecondLevelType,
  VerticalMenuItemsType,
} from './vertical-menu-types';

const COMPONENT_LOCAL_STORAGE_KEY = 'wk-vertical-menu-state';

function getFullStorage() {
  const currentStateInString = localStorage.getItem(
    COMPONENT_LOCAL_STORAGE_KEY
  );
  return currentStateInString ? JSON.parse(currentStateInString) : {};
}

export function getHorizontalCollapseLocalStorage(menuKey?: string) {
  return menuKey ? getFullStorage()[menuKey] : false;
}

export function setHorizontalCollapseLocalStorage(
  menuKey: string,
  isCollapsed: boolean
) {
  const currentState = getFullStorage();

  const newState = { ...currentState, [menuKey]: isCollapsed };
  const serializedNewState = JSON.stringify(newState);
  localStorage.setItem(COMPONENT_LOCAL_STORAGE_KEY, serializedNewState);
}

export function findActiveParentMenu(
  level: number,
  pathname: string,
  items: VerticalMenuItemsType[]
): string {
  return items.reduce((acc, item: VerticalMenuItemsType) => {
    if (acc) return acc;

    if (item?.redirectTo && pathname.includes(item.redirectTo)) {
      return `${level}-${item.name}`;
    }

    if (item.children) {
      const resultChildren = findActiveParentMenu(
        level + 1,
        pathname,
        item.children
      );

      return resultChildren ? `${level}-${item.name}` : '';
    }

    return '';
  }, '');
}

export function mapItemsWithChildrenWithLevel(
  items: VerticalMenuSecondLevelType[],
  outerAccumulator = {},
  level = 1
): Record<string, boolean> {
  return items.reduce((acc, item) => {
    if (item.children) {
      return mapItemsWithChildrenWithLevel(
        item.children,
        {
          [`${level}-${item.name}`]: false,
          ...acc,
        },
        level + 1
      );
    }

    return acc;
  }, outerAccumulator);
}

function countChildren(items?: VerticalMenuSecondLevelType[]): number {
  if (!items) return 0;

  return items.reduce((acc, item: VerticalMenuSecondLevelType) => {
    return item.children ? acc + countChildren(item.children) : acc;
  }, items.length);
}

export function calcChildrenHeight(
  items?: VerticalMenuSecondLevelType[]
): number {
  const ITEM_HEIGHT = 36;

  return countChildren(items) * ITEM_HEIGHT;
}

export function findFirstLevelParentItem(
  items: VerticalMenuItemsType[],
  childName: string
): VerticalMenuItemsType | undefined {
  return items
    .filter((filterItem: VerticalMenuItemsType) => !!filterItem.children)
    .find((item: VerticalMenuItemsType) => {
      if (item.name === childName) return true;

      if (item.children) {
        return !!findFirstLevelParentItem(item.children, childName);
      }

      return;
    });
}
